import { attentionTooltip } from './attentionText';
import type { AttentionSummary } from './types';

/**
 * Option B top-level cue: a dot at its host's corner.
 * The host MUST be `position: relative` (or otherwise a containing block): the
 * dot is absolutely positioned and would otherwise escape to a distant ancestor
 * and its scroll container. It is aria-hidden; the host carries the accessible
 * name (e.g. `attentionAriaLabel`).
 */
export function AttentionDot({ summary }: Readonly<{ summary: AttentionSummary }>) {
  if (summary.total === 0 || !summary.worst) return null;
  return (
    <span
      className={`attention-dot is-${summary.worst}`}
      aria-hidden="true"
      title={attentionTooltip(summary)}
      data-attention="dot"
    />
  );
}
